import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import styles from './logs-placeholder.styl'
import img from 'assets/img/logs-placeholder.png'

export default class LogsPlaceholder extends PureComponent {
  static propTypes = {
    customMessage: PropTypes.string
  }

  render() {
    return (
      <div className={styles.wrap}>
        <img
          className={styles.img}
          src={img}
          alt="DofE Logs placeholder"
          width="230"
          height="57"
        />
        <p className={styles.caption}>
          {this.props.customMessage || (
            <FormattedHTMLMessage
              id="label.no_logs_yet"
              defaultMessage="No logs yet.<br />Try to add first one by pressing<br />ADD LOG button."
            />
          )}
        </p>
      </div>
    )
  }
}
